import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon2 from 'components/media/Icon2/index.js';

const ColoredIcon = styled(Icon2)`
  width: 14px;
  &.ss-question {
    color: ${(p) => p.theme.grayLight};
  }
  &.ss-checkmark {
    color: ${(p) => p.theme.brandSuccess};
  }
  &.ss-delete {
    color: ${(p) => p.theme.brandDanger};
  }
`;

function getIconClass(value) {
  switch (value) {
    case true:
      return 'ss-checkmark';
    case false:
      return 'ss-delete lower-1';
    default:
      return 'ss-question lower-1';
  }
}

function ConsentIcon(props) {
  const { value, className = '', ...rest } = props;
  const iconClass = `${className} ${getIconClass(value)}`;
  return (
    <ColoredIcon className={iconClass} {...rest} />
  );
}

ConsentIcon.propTypes = {
  value: PropTypes.bool,
  className: PropTypes.string,
};

export default ConsentIcon;
